import { baseApi } from './baseApi';

export interface PurchaseProductRequest {
  productId: string;
}

export interface PurchaseProductResponse {
  status: 'success';
  message: string;
  data: {
    purchase: {
      productId: string;
      categoryId: string;
      productName: string;
      categoryName: string;
      value: string;
      purchasedAt: string;
      price: number;
    };
  };
}

export interface PurchaseCategoryRequest {
  categoryId: string;
}

export interface PurchaseCategoryResponse {
  status: 'success';
  message: string;
  data: {
    purchase: {
      productId: string;
      categoryId: string;
      productName: string;
      categoryName: string;
      value: string;
      purchasedAt: string;
      price: number;
    };
  };
}

export interface GetPurchasesParams {
  categoryId?: string;
  page?: number;
  limit?: number;
}

export interface Purchase {
  transactionId: string;
  productId: string;
  categoryId: string;
  productName: string;
  categoryName: string;
  price: number;
  purchasedAt: string;
  transactionDetails: {
    productId: string;
    categoryId: string;
    productName: string;
    categoryName: string;
    paymentMethod: string;
    /** القيمة الفعلية للمنتج (يظهر بعد الشراء) */
    productValue?: string;
  };
}

export interface GetPurchasesResponse {
  status: 'success';
  message: string;
  data: {
    purchases: Purchase[];
    pagination: {
      page: number;
      limit: number;
      total: number;
      pages: number;
    };
  };
}

export const productsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Purchase Product by ID
    purchaseProduct: builder.mutation<PurchaseProductResponse, PurchaseProductRequest>({
      query: ({ productId }) => ({
        url: `/products/${productId}/purchase`,
        method: 'POST',
      }),
      invalidatesTags: ['Products', 'Categories', 'Balance'],
    }),

    // Purchase Product from Category
    purchaseCategory: builder.mutation<PurchaseCategoryResponse, PurchaseCategoryRequest>({
      query: ({ categoryId }) => ({
        url: `/categories/${categoryId}/purchase`,
        method: 'POST',
      }),
      invalidatesTags: ['Products', 'Categories', 'Balance'],
    }),

    // Get User Purchases
    getPurchases: builder.query<GetPurchasesResponse, GetPurchasesParams>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        
        if (params.categoryId) searchParams.append('categoryId', params.categoryId);
        if (params.page) searchParams.append('page', params.page.toString());
        if (params.limit) searchParams.append('limit', params.limit.toString());

        const queryString = searchParams.toString();
        return {
          url: `/products/purchases${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
      providesTags: ['Purchases'],
    }),
  }),
});

export const {
  usePurchaseProductMutation,
  usePurchaseCategoryMutation,
  useGetPurchasesQuery,
} = productsApi;

